/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState } from "react";
import { sendEmailOTP } from "api/OTPService";
import { findUserByEmail } from "api/UserAPI";
import TextField from "@mui/material/TextField";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { Alert, Box, Snackbar, Typography, Backdrop, CircularProgress } from "@mui/material";
import Navbars from "examples/Navbars";
// import useEnterKeyEvent from "hooks/useEnterKeyEvent";
import SuiTypography from "components/SuiTypography";
// import PageLayout from "examples/LayoutContainers/PageLayout";
import refreshButton from "assets/images/refreshButton.png";
import ValidateOTP from "../sign-up/validateOTP";
import ConfirmResetPass from "./component/resetPassword/confirmResetPass";
import HandleGenCapchaRandomRotate from "./component/Capcha/Capcha";

const step = {
  phoneNumberInput: 0,
  otpInput: 1,
};

function Forgot() {
  const [username, setUserName] = useState();
  const [isLoginFail, setIsLoginfail] = useState(false);
  const [currentStep, setCurrentStep] = useState(step.phoneNumberInput);
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaImg, setcaptchaImg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [emailError, setEmailError] = useState("");

  // Regex kiểm tra định dạng email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Hàm kiểm tra email
  const validateEmail = async (email) => {
    // Kiểm tra định dạng email
    if (!emailRegex.test(email)) {
      setEmailError("Email không đúng định dạng. Vui lòng nhập email hợp lệ.");
      return false;
    }

    try {
      // Kiểm tra email có tồn tại trong hệ thống không
      const result = await findUserByEmail(email);
      if (result.status === 404) {
        setEmailError("Email không tồn tại trong hệ thống.");
        return false;
      }
      if (result.status === 200) {
        setEmailError(""); // Clear error nếu email hợp lệ
        return true;
      }
      setEmailError("Có lỗi xảy ra khi kiểm tra email. Vui lòng thử lại.");
      return false;
    } catch (error) {
      setEmailError("Có lỗi xảy ra khi kiểm tra email. Vui lòng thử lại.");
      return false;
    }
  };

  async function handleResetPassWord() {
    // Kiểm tra email trước khi tiếp tục
    if (!username || username.trim() === "") {
      setEmailError("Vui lòng nhập email.");
      return;
    }

    const isEmailValid = await validateEmail(username.trim());
    if (!isEmailValid) {
      return; // Dừng lại nếu email không hợp lệ
    }

    if (captchaImg === captchaInput) {
      setIsLoading(true);
      const check = await sendEmailOTP(username);
      if (check.status === 200) {
        setCurrentStep(2);
        setIsLoading(false);
      } else {
        Swal.fire("Lỗi", "Email không tồn tại trong hệ thống", "error");
        setIsLoading(false);
      }
    } else {
      setIsLoginfail(true);
    }
  }
  async function onViewChangePassword() {
    setCurrentStep(1);
  }
  const [isBackButtonClicked, setBackbuttonPress] = useState(false);

  const onBackButtonEvent = (e) => {
    e.preventDefault();
    if (isBackButtonClicked) {
      setBackbuttonPress(false);
    } else {
      window.history.pushState(null, null, window.location.pathname);
      setBackbuttonPress(true);
    }
  };
  const handleGenCapcha = () => {
    const charset = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let result = "";

    for (let i = 0; i < 3; i += 1) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      result += charset.charAt(randomIndex);
    }
    setcaptchaImg(result);
  };

  // useEnterKeyEvent([username, captchaInput], handleResetPassWord);

  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", onBackButtonEvent);
    return () => {
      window.removeEventListener("popstate", onBackButtonEvent);
    };
  }, []);
  useEffect(() => {
    const charset = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let result = "";

    for (let i = 0; i < 3; i += 1) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      result += charset.charAt(randomIndex);
    }
    setcaptchaImg(result);
  }, []);
  return (
    <SuiBox
      sx={{
        backgroundColor: "#386b59 !important",
      }}
    >
      <Navbars />

      {currentStep === 0 ? (
        <SuiBox sx={{ display: "flex", justifyContent: "center", paddingTop: "150px" }}>
          <Box
            sx={{
              width: {
                xs: "80%", // mobile
                sm: "90%", // tablet
                md: "550px", // desktop
              },
            }}
          >
            <SuiBox sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
              <Typography sx={{ fontWeight: 700, fontSize: 25 }}>Đặt lại mật khẩu</Typography>

              <SuiBox sx={{ display: "flex", marginBottom: 2 }}>
                <Typography sx={{ fontSize: 14 }}>Trở về </Typography>
                <Typography
                  component={Link}
                  to="/authentication/sign-in"
                  variant="button"
                  sx={{
                    fontSize: 14,
                    marginLeft: "6px",
                    fontWeight: "regular",
                    color: "var(--blue-blue-100)",
                    cursor: "pointer",
                    textTransform: "none",
                  }}
                >
                  Đăng nhập
                </Typography>
              </SuiBox>
            </SuiBox>

            <SuiBox className="w-100">
              <SuiBox>
                {/* Nhập email */}
                <SuiBox mb={2}>
                  <SuiTypography
                    sx={{
                      fontSize: "16px",
                      color: "var(--gray-100)",
                      fontWeight: "600",
                      textTransform: "none",
                    }}
                  >
                    Email
                  </SuiTypography>
                  <TextField
                    value={username || ""}
                    onChange={(e) => {
                      setUserName(e.target.value);
                      setEmailError(""); // Clear error khi user nhập lại
                    }}
                    required
                    error={!!emailError}
                    helperText={emailError}
                    sx={{
                      width: "100%",
                      "& .MuiFilledInput-root": {
                        backgroundColor: "var(--blue-gray-line) !important",
                      },
                      "& .MuiFilledInput-input": {
                        height: "22.02px",
                        width: "100% !important",
                        "::placeholder": {
                          fontStyle: "italic",
                        },
                      },
                      "& .MuiFilledInput-root:before,& .MuiFilledInput-root:after": {
                        border: "none",
                        content: "none",
                      },
                      "& label.Mui-focused": {
                        color: "var(--blue-blue-100)",
                      },
                      "& .MuiInputLabel-root": {
                        color: "#aeaeae",
                      },
                      "& .MuiFormHelperText-root": {
                        color: "#d32f2f",
                        fontSize: "12px",
                      },
                      // "& .Mui-focused": {
                      //   borderColor: "var(--blue-blue-100) !important",
                      // },
                    }}
                    variant="filled"
                    placeholder="Nhập email của bạn"
                  />
                </SuiBox>

                {/* Nhập mã CAPTCHA */}
                <SuiBox mb={2}>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      color: "var(--gray-100)",
                      fontWeight: "600",
                      textTransform: "none",
                    }}
                    mb={0.7}
                  >
                    Mã CAPTCHA
                  </Typography>
                  <SuiBox sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                    <TextField
                      value={captchaInput || ""}
                      onChange={(e) => setCaptchaInput(e.target.value)}
                      variant="filled"
                      sx={{
                        width: "100%",
                        "& .MuiFilledInput-root": {
                          backgroundColor: "var(--blue-gray-line) !important",
                        },
                        "& .MuiFilledInput-input": {
                          height: "22.02px",
                          width: "100% !important",
                          "::placeholder": {
                            fontStyle: "italic",
                          },
                        },
                        "& .MuiFilledInput-root:before,& .MuiFilledInput-root:after": {
                          border: "none",
                          content: "none",
                        },
                        "& label.Mui-focused": {
                          color: "var(--blue-blue-100)",
                        },
                        "& .MuiInputLabel-root": {
                          color: "#aeaeae",
                        },
                        // "& .Mui-focused": {
                        //   borderColor: "var(--blue-blue-100) !important",
                        // },
                      }}
                    />
                    <HandleGenCapchaRandomRotate captcha={captchaImg} />
                    <Box
                      component="img"
                      src={refreshButton}
                      onClick={handleGenCapcha}
                      sx={{ width: "5%", height: 1, cursor: "pointer" }}
                    />
                  </SuiBox>
                </SuiBox>

                {/* Nút xác nhận */}
                <SuiBox mb={2} textAlign="center">
                  <SuiButton
                    size="small"
                    color="var(--blue-blue-100)"
                    circular
                    type="button"
                    sx={{
                      width: "100% !important",
                      background: "var(--blue-blue-100)",
                      borderRadius: "15px",
                      padding: "8px 24px",
                    }}
                    onClick={handleResetPassWord}
                  >
                    <Typography whiteSpace="nowrap" variant="body2" color="white" fontSize="18px">
                      Lấy mã xác thực
                    </Typography>
                  </SuiButton>
                </SuiBox>
              </SuiBox>
            </SuiBox>

            {/* Thông báo lỗi */}
            {isLoginFail && (
              <Snackbar
                open={isLoginFail}
                autoHideDuration={3000}
                onClose={() => setIsLoginfail(false)}
              >
                <Alert
                  severity="error"
                  sx={{ width: "100%" }}
                  onClose={() => setIsLoginfail(false)}
                >
                  Tên đăng nhập hoặc mã CAPTCHA không đúng.
                </Alert>
              </Snackbar>
            )}
          </Box>
        </SuiBox>
      ) : currentStep === 1 ? (
        <ConfirmResetPass username={username} handleSignUp={onViewChangePassword} />
      ) : (
        <ValidateOTP username={username} handleSignUp={onViewChangePassword} />
      )}
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </SuiBox>
  );
}

export default Forgot;
